import React, { useState } from 'react';
import TopBar from './TopBar';
import Sidebar from './Sidebar';

// Therapist sidebar shell — the default chrome for all /therapist routes. It is
// chrome-only (like the former TherapistHeader AppBar it replaced): it
// renders the fixed TopBar + Sidebar as siblings to the app's main content
// container, which applies the matching left/top offset when the flag is on
// (see App.js). This keeps the swap a single conditional with instant rollback.

const TherapistLayout = ({ user, onLogout, onChangePassword, onDeleteAccount, pageTitle }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <TopBar
        user={user}
        onLogout={onLogout}
        onChangePassword={onChangePassword}
        onDeleteAccount={onDeleteAccount}
        pageTitle={pageTitle}
        onMenuClick={() => setMobileOpen((v) => !v)}
      />
      <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
    </>
  );
};

export default TherapistLayout;
